import request from '@/utils/requestVr'

export function fetchList(query) {
    return request({
        url: '/vr/scheme/page',
        method: 'get',
        params: query,
    })
}

export function addObj(query) {
    return request({
        url: '/vr/scheme/add',
        method: 'post',
        data: query,
    })
}

export function editObj(query) {
    return request({
        url: '/vr/scheme/edit',
        method: 'post',
        data: query,
    })
}


export function getObj(schemeId) {
    return request({
        url: '/vr/scheme/detail?schemeId=' + schemeId,
        method: 'get',
    })
}

export function delObj(data) {
    return request({
        url: '/vr/scheme/delete',
        method: 'post',
        data: data,
    })
}

 